var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFantom = function SvgFantom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.75 5.062 7 3.749v2.625L4.75 5.062ZM7 10.687l-3 1.75-3-1.75V7.623l3 1.75 3-1.75v3.063ZM1 3.749l2.25 1.313L1 6.374V3.749Zm3.375 1.938 2.25 1.312-2.25 1.313V5.687Zm-.75 2.625-2.25-1.313 2.25-1.312v2.625Zm3-5.188L4 4.624l-2.625-1.5L4 1.562l2.625 1.562ZM.25 2.874v8.188L4 13.187l3.75-2.125V2.873L4 .749.25 2.874Z",
    fill: "currentColor"
  })));
};
export default SvgFantom;